<template>
  <div class="gif-player"></div>
</template>

<script>
import delayFunc from "@/utils/delay";
import { resolveResourceUrl } from "@/constants";

// GIF 오버레이 플레이어. cmd argSchema1(targetKey 사용자 | targetFileName 글로벌)을 받아 <img>로 표시.
//  브라우저가 gif 자체를 애니메이션하므로 별도 디코딩 불필요. duration 후 자동 제거(0이면 기본 유지).
const DEFAULT_DURATION = 8 * 1000;

export default {
  methods: {
    // arg: 문자열(글로벌 fileName) | { targetFileName, targetKey }. options: { delay, duration(ms) }
    async play(arg, options = {}) {
      const src = resolveResourceUrl(arg, "gifs");
      if (!src) return;

      const { delay = 0, duration = DEFAULT_DURATION } = options || {};
      this.stop();

      await delayFunc(delay);

      const img = document.createElement("img");
      img.className = "gif-player__img";
      img.src = src;
      this.$el.appendChild(img);

      if (duration && duration > 0) {
        await delayFunc(duration);
        if (img.parentNode === this.$el) this.$el.removeChild(img);
      }
    },
    stop() {
      this.$el.querySelectorAll(".gif-player__img").forEach((el) => this.$el.removeChild(el));
    },
  },
  destroyed() {
    this.stop();
  },
};
</script>

<style scoped>
.gif-player {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.gif-player__img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 60%;
  max-height: 60%;
}
</style>
